var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalcMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.673,
    height: 27.564,
    viewBox: "0 0 20.673 27.564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7647",
    "data-name": "Grupo 7647",
    transform: "translate(-769.606 -364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calculator",
    transform: "translate(769.606 364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2464",
    "data-name": "Trazado 2464",
    d: "M19.228,1.723a1.723,1.723,0,0,1,1.723,1.723V24.119a1.723,1.723,0,0,1-1.723,1.723H5.446a1.723,1.723,0,0,1-1.723-1.723V3.446A1.723,1.723,0,0,1,5.446,1.723ZM5.446,0A3.446,3.446,0,0,0,2,3.446V24.119a3.446,3.446,0,0,0,3.446,3.446H19.228a3.446,3.446,0,0,0,3.446-3.446V3.446A3.446,3.446,0,0,0,19.228,0Z",
    transform: "translate(-2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2465",
    "data-name": "Trazado 2465",
    d: "M4,2.861A.861.861,0,0,1,4.861,2H16.921a.861.861,0,0,1,.861.861V6.307a.861.861,0,0,1-.861.861H4.861A.861.861,0,0,1,4,6.307ZM4,9.753a.861.861,0,0,1,.861-.861H6.584a.861.861,0,0,1,.861.861v1.723a.861.861,0,0,1-.861.861H4.861A.861.861,0,0,1,4,11.475Zm0,5.168a.861.861,0,0,1,.861-.861H6.584a.861.861,0,0,1,.861.861v1.723a.861.861,0,0,1-.861.861H4.861A.861.861,0,0,1,4,16.644Zm0,5.168a.861.861,0,0,1,.861-.861H6.584a.861.861,0,0,1,.861.861v1.723a.861.861,0,0,1-.861.861H4.861A.861.861,0,0,1,4,21.812ZM9.168,9.753a.861.861,0,0,1,.861-.861h1.723a.861.861,0,0,1,.861.861v1.723a.861.861,0,0,1-.861.861H10.03a.861.861,0,0,1-.861-.861Zm0,5.168a.861.861,0,0,1,.861-.861h1.723a.861.861,0,0,1,.861.861v1.723a.861.861,0,0,1-.861.861H10.03a.861.861,0,0,1-.861-.861Zm0,5.168a.861.861,0,0,1,.861-.861h1.723a.861.861,0,0,1,.861.861v1.723a.861.861,0,0,1-.861.861H10.03a.861.861,0,0,1-.861-.861ZM14.337,9.753a.861.861,0,0,1,.861-.861h1.723a.861.861,0,0,1,.861.861v1.723a.861.861,0,0,1-.861.861H15.2a.861.861,0,0,1-.861-.861Zm0,5.168a.861.861,0,0,1,.861-.861h1.723a.861.861,0,0,1,.861.861v6.891a.861.861,0,0,1-.861.861H15.2a.861.861,0,0,1-.861-.861Z",
    transform: "translate(-0.554 1.446)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcMenu);
export default __webpack_public_path__ + "static/media/calc-menu.7b99dd07e14e02401af38c6b33f5e572.svg";
export { ForwardRef as ReactComponent };